import { StateUtils } from '@spartacus/core';
import { SearchPageResultState } from '../../../features/store/base-feature-state';
import { OrderApprovalSearchResult } from '../../../model';
import { UserActions } from '../actions';

export const initialState: SearchPageResultState = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer(state = initialState, action: UserActions.LoadOrderApprovalsSuccess | StateUtils.LoaderAction): any {
  switch (action.type) {
    case UserActions.OrderApprovalActionTypes.LOAD_ORDER_APPROVALS_SUCCESS:
    case UserActions.OrderApprovalActionTypes.LOAD_ORDER_APPROVALS_ADMIN_SUCCESS: {
      const payload: OrderApprovalSearchResult = action.payload;

      const results = payload.results.map((order) => order.code);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    case UserActions.OrderApprovalActionTypes.LOAD_ORDER_APPROVALS_RESET:
    case UserActions.OrderApprovalActionTypes.LOAD_ORDER_APPROVALS_ADMIN_RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
